<template>
  <div class="item__container">
    <div class="item__image-wrapper">
      <img class="item__image" :src="propertyValue.img" alt="" />
    </div>
    <div class="item__content">
      <div class="item__content-column direction__column">
        <h2 class="direction__heading">{{ propertyValue.title }}</h2>
        <span class="direction__place">{{ propertyValue.add }}</span>
      </div>
      <div class="item__columns">
        <div class="item__content-column">
          <span class="column__title">Precio del Token</span>
          <span class="column__data">${{ propertyValue.tokenPrice }}</span>
        </div>
        <div class="item__content-column">
          <span class="column__title">Cap Rate</span>
          <span class="column__data">{{propertyValue.capRate}}%</span>
        </div>
        <div class="item__content-column">
          <span class="column__title">Plusvalía Proyectada</span>
          <span class="column__data">{{propertyValue.projAppreciation}}%</span>
        </div>
        <div class="item__content-column">
          <span class="column__title">TIR Proyectada</span>
          <span class="column__data">{{propertyValue.projIRR}}%</span>
        </div>
        <div class="item__content-column">
          <span class="column__title">Rendimientos Sobre Capital Invertidos</span>
          <div class="column__data">{{ propertyValue.coc }}%</div>
        </div>
      </div>
      <div class="item__content-column">
        <a :href="'/property-detail/' + propertyValue.slug" class="btn">
          Ver
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HouseListItem',
  props: {
    property: {
      type: Object,
      required: true,
      default:{}
    }
  },
  data () {
    return {
      propertyValue: {
        img: '',
        title: '',
        subtitle: '',
        description: '',
        irr:'',
        coc:'',
        add:'',
        tokenPrice: null,
        capRate: null,
        projAppreciation: null,
        projIRR: null,
        tokenSold: false,
        isFeatured: false,
        isNewListening: null,
        slug:''
      }
    }
  },
  created(){
    console.log("house",this.property.attributes.property_financial.data.attributes)
    let financialData = this.property.attributes.property_financial.data.attributes
    this.propertyValue.img = this.property.attributes.Images.data[0].attributes.formats.thumbnail.url
    this.propertyValue.title = this.property.attributes.Name
    this.propertyValue.irr = financialData.IRR
    this.propertyValue.coc = financialData.Coc
    this.propertyValue.add = this.property.attributes.Address
    this.propertyValue.tokenPrice = financialData.TokenPrice
    this.propertyValue.capRate = financialData.CapRate
    this.propertyValue.projAppreciation = financialData.ProjectedAppreciation
    this.propertyValue.projIRR = financialData.ProjIRR
    this.propertyValue.tokenSold = financialData.TokenSold
    this.propertyValue.isFeatured = this.property.attributes.isFeatured
    this.propertyValue.isNewListening = this.property.attributes.isNewListening
    this.propertyValue.slug = this.property.attributes.slug
    

  },
  methods: {
    formatNumber(value) {
      return numeral(value).format("0,0.0")
    }
  }
}
</script>
<style lang="scss">
.item__container {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  overflow: hidden;
  border-radius: 16px;
  z-index: 1;
}

.item__image-wrapper {
  position: relative;
  max-width: 248px;
  flex-shrink: 0;
}

.item__image {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.item__content {
  display: flex;
  gap: 28px;
  padding: 0 20px;
  align-items: center;
  width: 100%;
}

.item__columns {
  display: flex;
  gap: 16px;
  width: 100%;
}

.item__content-column {
  display: flex;
  flex-direction: column;
  font-family: 'Roboto', sans-serif;
  &.direction__column {
    flex-shrink: 0;
  }
  
  .direction__heading {
    font-size: 18px;
    line-height: 22px;
    margin: 0;
  }

  .direction__place {
    font-size: 11px;
    line-height: 20px;
    color: #3A2E85;
  }

  .column__title {
    font-size: 12px;
    line-height: 18px;
    color: #3A2E85;
  }

  .column__data {
    font-size: 18px;
    line-height: 22px;
    text-align: center;
  }
}

.btn {
  padding: 8px 16px;
  border-radius: 8px;
  background-color: #3A2E85;
  color: #CAEEDD;
  font-size: 14px;
  line-height: 32px;
  min-width: 120px;
}
.btn:hover {
  color: #CAEEDD;
}
</style>